import { render, staticRenderFns } from "./LoginCardUnauthorized.vue?vue&type=template&id=70652c3f&scoped=true"
import script from "./LoginCardUnauthorized.vue?vue&type=script&lang=ts"
export * from "./LoginCardUnauthorized.vue?vue&type=script&lang=ts"
import style0 from "./LoginCardUnauthorized.vue?vue&type=style&index=0&id=70652c3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70652c3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBanner,VBtn,VCard,VCardText,VCardTitle,VContainer,VImg})
